<template>
  <div class="informasi_pembayaran">
    <SOSlotBase :container-name="`pemilihan_pembayaran`" :loading="isLoading">
      <template v-slot:title-bar>
        <SOTitleBar :page-title="'Pembayaran'" :type="'back'" @back="back" />
      </template>

      <template v-slot:loading-page>
        <SOLoadingPage />
      </template>
      <template v-slot:content>
        <div class="p-x-20">
          <div class="f-16 f-regular f-c-primary p-y-16">
            <p class="m-d-0">
              Anda akan melakukan pembayaran training sebesar
              <span style="font-weight: bold">Rp 500.000</span>
              untuk akun
              <span style="font-weight: bold">lilulalita@email.com</span>
            </p>
            <p class="m-d-0" style="color: #da1e28; margin-top: 16px">
              Pastikan akun smartlink sudah sesuai. Jangan bayar sebelum
              <span style="font-weight: bold"
                >klik tombol Buat Tagihan 500.200</span
              >
            </p>
          </div>
        </div>
        <hr />
        <div class="p-x-20">
          <div class="p-x-20 p-y-14" style="background-color: #439480">
            <div class="d-flex-between-center">
              <p class="f-14 f-Overpass p-t-16 f-c-white remove-margin">
                Yeay! Selamat, Kamu Mendapatkan
              </p>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                class="remove-margin"
                style="margin-top: 16px"
              >
                <g clip-path="url(#clip0_1449_36766)">
                  <path
                    d="M15.8538 12.8541L10.9998 8.00008L15.8538 3.14608C15.9468 3.05193 15.999 2.92492 15.999 2.79258C15.999 2.66023 15.9468 2.53322 15.8538 2.43908L13.5608 0.146076C13.5145 0.0995436 13.4594 0.0626219 13.3987 0.0374289C13.3381 0.012236 13.273 -0.000732422 13.2073 -0.000732422C13.1416 -0.000732422 13.0766 0.012236 13.0159 0.0374289C12.9553 0.0626219 12.9002 0.0995436 12.8538 0.146076L7.99983 5.00008L3.14583 0.146076C3.05207 0.0523407 2.92491 -0.000317003 2.79233 -0.000317003C2.65975 -0.000317003 2.5326 0.0523407 2.43883 0.146076L0.145832 2.43908C0.0992995 2.48544 0.0623778 2.54053 0.0371848 2.60119C0.0119919 2.66185 -0.000976562 2.72689 -0.000976562 2.79258C-0.000976562 2.85826 0.0119919 2.9233 0.0371848 2.98396C0.0623778 3.04462 0.0992995 3.09972 0.145832 3.14608L4.99983 8.00008L0.145832 12.8541C0.0520965 12.9478 -0.000561144 13.075 -0.000561144 13.2076C-0.000561144 13.3402 0.0520965 13.4673 0.145832 13.5611L2.43883 15.8541C2.48519 15.9006 2.54028 15.9375 2.60095 15.9627C2.66161 15.9879 2.72665 16.0009 2.79233 16.0009C2.85802 16.0009 2.92306 15.9879 2.98372 15.9627C3.04438 15.9375 3.09947 15.9006 3.14583 15.8541L7.99983 11.0001L12.8538 15.8541C12.9476 15.9478 13.0748 16.0005 13.2073 16.0005C13.3399 16.0005 13.4671 15.9478 13.5608 15.8541L15.8538 13.5611C15.9004 13.5147 15.9373 13.4596 15.9625 13.399C15.9877 13.3383 16.0006 13.2733 16.0006 13.2076C16.0006 13.1419 15.9877 13.0769 15.9625 13.0162C15.9373 12.9555 15.9004 12.9004 15.8538 12.8541Z"
                    fill="white"
                    fill-opacity="0.5"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1449_36766">
                    <rect width="16" height="16" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <p
              class="f-Overpass f-14 f-c-white"
              style="font-weight: 600; padding: 5px"
            >
              1. Diskon 10%
            </p>
          </div>
        </div>

        <div class="p-t-16 p-x-20">
          <SOInputSelect
            :required="true"
            :title="'Catat Sebagai Biaya dari Akun'"
            :placeholder="'Pilih Nama Bank'"
          />
          <!-- :options="dataListBank"
            :selected="selectedBank"
            @option-selected="optionSelected" -->
        </div>

        <hr style="width: 95%; margin: 0 auto; margin-top: 16px" />

        <div class="p-x-20 p-t-16">
          <div class="form-control" style="height: max-content">
            <div class="p-x-20 p-t-16 d-flex-align-center menu-1">
              <input
                type="radio"
                name="viaBank"
                id="viaBank"
                @click="viaBank"
              />
              <div class="text" style="margin-left: 16px">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M12.75 3H3.25C2.2835 3 1.5 3.7835 1.5 4.75V11.25C1.5 12.2165 2.2835 13 3.25 13H12.75C13.7165 13 14.5 12.2165 14.5 11.25V4.75C14.5 3.7835 13.7165 3 12.75 3Z"
                    stroke="#545454"
                    stroke-width="0.75"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M1.5 6H14.5M4 9.375H5.5V10H4V9.375Z"
                    stroke="#545454"
                    stroke-width="1.40625"
                    stroke-linejoin="round"
                  />
                </svg>
                <label
                  class="f-Overpass f-14 f-c-black remove-margin"
                  style="font-weight: bolder; margin-left: 3px"
                >
                  Via Transfer Bank (BNI, BCA)</label
                >
                <div class="text-sub">
                  Biaya Administrasi Rp 100 - Rp 999 Proses Pengecekan (Approval
                  Maks 1 Jam 5 menit)
                </div>
              </div>
            </div>
            <hr style="width: 95%; margin: 0 auto" />
            <div class="p-x-20 p-t-16 d-flex-align-center menu-2">
              <input type="radio" name="viaQR" id="viaQR" @click="viaQR" />
              <div class="text" style="margin-left: 16px">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M12.75 3H3.25C2.2835 3 1.5 3.7835 1.5 4.75V11.25C1.5 12.2165 2.2835 13 3.25 13H12.75C13.7165 13 14.5 12.2165 14.5 11.25V4.75C14.5 3.7835 13.7165 3 12.75 3Z"
                    stroke="#545454"
                    stroke-width="0.75"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M1.5 6H14.5M4 9.375H5.5V10H4V9.375Z"
                    stroke="#545454"
                    stroke-width="1.40625"
                    stroke-linejoin="round"
                  />
                </svg>
                <label
                  class="f-Overpass f-14 f-c-black remove-margin"
                  style="font-weight: bolder; margin-left: 3px"
                  >Via QRIS (Scan)
                  <span
                    style="
                      color: #24a148;
                      font-family: Overpass;
                      font-size: 9px;
                      font-style: normal;
                      font-weight: 400;
                      line-height: 150%; /* 13.5px */
                      letter-spacing: -0.18px;
                    "
                    >Tercepat</span
                  ></label
                >
                <div class="text-sub">
                  Biaya Administrasi 0.2% (Rp 60) Pengecekan Otomatis, Langsung
                  Masuk Gopay, OVO, DANA, ShopeePay, M-BCA, Mandiri, BRI dan
                  Semua Bank serta E-Wallet yang support QRIS (Approval Maks 30
                  Menit)
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="p-x-20 btn_menu">
          <button
            type="button"
            class="btn btn-outline-primary btn-long"
            @click="routeToKembali"
            id="buttonkembali"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="21"
              viewBox="0 0 24 25"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12.7071 4.79289C13.0976 5.18342 13.0976 5.81658 12.7071 6.20711L7.41421 11.5H19C19.5523 11.5 20 11.9477 20 12.5C20 13.0523 19.5523 13.5 19 13.5H7.41421L12.7071 18.7929C13.0976 19.1834 13.0976 19.8166 12.7071 20.2071C12.3166 20.5976 11.6834 20.5976 11.2929 20.2071L4.29289 13.2071C3.90237 12.8166 3.90237 12.1834 4.29289 11.7929L11.2929 4.79289C11.6834 4.40237 12.3166 4.40237 12.7071 4.79289Z"
                fill="#206CFF"
              />
            </svg>
            Kembali
          </button>
          <button
            id="btn_simpan"
            type="button"
            class="btn btn-login btn-long remove-margin"
            @click="routeToBayar"
          >
            Buat Tagihan 500.200
          </button>
        </div>
      </template>
    </SOSlotBase>
  </div>
</template>

<script>
import SOSlotBase from "@/so-components/global/slot/SOSlotBase.vue";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar.vue";
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";
import SOInputSelect from "@/so-components/global/input/SOInputSelect";
import SORadioBtn from "@/so-components/global/ui/SORadioBtn";

export default {
  name: "pembayaranPilih",
  components: {
    SOTitleBar: SOTitleBar,
    SOSlotBase: SOSlotBase,
    SOLoadingPage: SOLoadingPage,
    SOInputSelect: SOInputSelect,
    SORadioBtn: SORadioBtn,
  },
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    routeToBayar() {
      this.$router.push("/pembayaranViaQR");
    },
    routeToKembali() {
      this.$router.push("/infomasiPendaftaran_Bayar_TrainingOnline");
    },
    viaBank() {
      this.$router.push("/pembayaranViaBank");
    },
    viaQR() {
      this.$router.push("/pembayaranViaQR");
    },
    back() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
.text-sub {
  color: var(--secondary-midgrey, #6f7287);
  font-family: Overpass;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 16.5px */
  letter-spacing: -0.22px;
}
.arrow {
  margin-left: 20px;
}
.promo {
  display: flex;
}
#input_text {
  width: 83%;
  border-radius: 4px 0px 0px 4px;
}
#btn_promo {
  background-color: #40964c;
  color: #ffff;
  border-radius: 0px 4px 4px 0px;
}

#Detail {
  font-family: Overpass;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: -0.32px;
  margin-left: 20px;
  margin-top: 10px;
}
.btn_menu {
  display: flex;
  justify-content: space-between;
  margin-top: 5%;
}
#buttonkembali {
  width: 35%;
}
#btn_simpan {
  width: 60%;
}
@media (min-width: 320px) and (max-width: 768px) {
  .btn_menu {
    display: flex;
    margin-top: 3%;
  }
  #text_field {
    width: 52%;
    border-radius: 4px 0px 0px 4px;
  }
}
</style>
